module.exports = __webpack_public_path__ + "media/case-alert.77e4ae16.mp3";